// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--gUPQ4","arrow-left":"_02712f2b3b--arrow-left--LYdof","arrow-right":"_02712f2b3b--arrow-right--YZWMq"};